// ################## IMPORTS
import { apiClient } from "connections/apiClient";
import apiRoutes from "connections/apiRoutes";

// ################## UTILITARY FUNCTIONS
// Transform inputColumns to setupkeyMerges
export function getSetupkeyMergeDefinition(inputColumns) {
  try {
    const setupkeyMerges = {};

    Object.entries(inputColumns).forEach(([tableId, tableData]) => {
      if (!tableData.columns) return;

      Object.entries(tableData.columns).forEach(([columnId, columnData]) => {
        // Filter only setup keys with column_table_setup defined
        if (
          columnData.is_setup_key &&
          columnData.column_table_setup &&
          columnData.column_table_setup.trim() !== ""
        ) {
          const targetTable = columnData.column_table_setup;
          const sourceTable = tableId;

          // Initialize structure if it doesn't exist
          if (!setupkeyMerges[targetTable]) {
            setupkeyMerges[targetTable] = {};
          }
          if (!setupkeyMerges[targetTable][sourceTable]) {
            setupkeyMerges[targetTable][sourceTable] = [];
          }

          // Add the setup key
          setupkeyMerges[targetTable][sourceTable].push(columnId);
        }
      });
    });

    console.log("🔑 Setup Key Merges (from inputColumns):", setupkeyMerges);
    return setupkeyMerges;
  } catch (error) {
    console.error("Error transforming setup key merge definition:", error);
    return {};
  }
}

// ################## API CALLS
// Get Setupkey Mapping
export async function getSetupkeyMapping(variantName) {
  try {
    const response = await apiClient.get(
      `${apiRoutes.setup.setupkeyMappings}?variant_name=${variantName}`,
    );
    return response.data || {};
  } catch (error) {
    console.error("Error loading setupkey mappings:", error);
    return {};
  }
}

// Save Setupkey Mapping
export async function saveSetupkeyMapping(variantName, mappings) {
  try {
    const response = await apiClient.post(apiRoutes.setup.setupkeyMappings, {
      variant_name: variantName,
      mappings: mappings,
    });
    return response.data;
  } catch (error) {
    console.error("Error saving setupkey mappings:", error);
    throw error;
  }
}
